"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedItemDiet = exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var feedItemDiet = feedItem => {
  if (!feedItem) return {};
  var {
    id,
    _metasPeers,
    _user,
    _feed,
    content,
    createdAt,
    updatedAt,
    specialType,
    metasDiff,
    metasBot,
    metasCRM,
    isUnread,
    metasLink,
    metasFile,
    metasQuote,
    isSending,
    isFailed,
    failureCode,
    failureMessage,
    user
  } = (0, _cloneDeep.default)(feedItem);
  var optionalParams = {};
  if (specialType) optionalParams.specialType = specialType;
  if (metasDiff) optionalParams.metasDiff = metasDiff;
  if (metasLink) optionalParams.metasLink = metasLink;
  if (metasBot) optionalParams.metasBot = metasBot;
  if (metasQuote) optionalParams.metasQuote = metasQuote;
  if (metasCRM) optionalParams.metasCRM = metasCRM;
  if (metasFile) {
    delete metasFile.path;
    delete metasFile.id;
    delete metasFile.namespace;
    optionalParams.metasFile = metasFile;
  }
  return _objectSpread({
    id,
    _metasPeers,
    _user,
    _feed,
    isUnread,
    content,
    createdAt,
    updatedAt,
    isSending,
    isFailed,
    failureCode,
    failureMessage,
    user
  }, optionalParams);
};
exports.feedItemDiet = feedItemDiet;
var _default = exports.default = {
  feedItemDiet
};